var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.527 1.53134C11.7767 1.47396 12.038 1.49574 12.2747 1.59365C12.5114 1.69156 12.7118 1.86074 12.848 2.07771L14.0739 4.03503C14.1728 4.19268 14.306 4.32592 14.4636 4.42477L16.421 5.65071C16.6384 5.78679 16.808 5.98727 16.9061 6.22424C17.0043 6.46122 17.0261 6.7229 16.9686 6.97286L16.4506 9.22248C16.4088 9.40429 16.4088 9.59321 16.4506 9.77502L16.9686 12.0259C17.0256 12.2755 17.0034 12.5366 16.9053 12.7731C16.8072 13.0096 16.6379 13.2096 16.421 13.3456L14.4636 14.5727C14.306 14.6716 14.1728 14.8048 14.0739 14.9625L12.848 16.9198C12.712 17.137 12.5117 17.3064 12.275 17.4046C12.0382 17.5027 11.7768 17.5247 11.527 17.4674L9.27619 16.9494C9.09478 16.9078 8.9063 16.9078 8.72489 16.9494L6.47403 17.4674C6.22425 17.5247 5.96284 17.5027 5.72612 17.4046C5.48939 17.3064 5.28912 17.137 5.15312 16.9198L3.92717 14.9625C3.82797 14.8047 3.6943 14.6714 3.5362 14.5727L1.58012 13.3468C1.36292 13.2108 1.19349 13.0105 1.09535 12.7738C0.997214 12.5371 0.97525 12.2757 1.03251 12.0259L1.54928 9.77502C1.59107 9.59321 1.59107 9.40429 1.54928 9.22248L1.03128 6.97286C0.973857 6.72277 0.995869 6.461 1.09425 6.22401C1.19262 5.98702 1.36247 5.78662 1.58012 5.65071L3.5362 4.42477C3.6943 4.32607 3.82797 4.19282 3.92717 4.03503L5.15312 2.07771C5.28921 1.86098 5.48936 1.69195 5.72582 1.59405C5.96227 1.49615 6.22333 1.47424 6.4728 1.53134L8.72489 2.04811C8.9063 2.08971 9.09478 2.08971 9.27619 2.04811L11.527 1.53134Z",
    stroke: "#00A8A8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.93555 10.1598L8.4454 12.5636L12.0653 6.43384",
    stroke: "#00A8A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificado);
export default __webpack_public_path__ + "static/media/verificado.d0b15b05368ca0713ed99a865332c5da.svg";
export { ForwardRef as ReactComponent };